import styled from '@emotion/styled';

export const StyledFieldsRow = styled.div`
  display: flex;
  width: 100%;
  gap: 1.5rem;
`;

export const StyledFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;
